export default __webpack_public_path__ + "static/media/section2-bg1.1758aa9c.png";